import '../../vendor/slick.js';

class SlickSlider {
  private element: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;
  }

  init(): void {
    $(this.element).slick();
  }
}

document.querySelectorAll('[data-slick]').forEach((element) => {
  new SlickSlider(element as HTMLElement).init();
});
